import { fetchOrder } from "@/features/wallet/wallet-api";

function normalize(value) {
  return value?.toString().toLowerCase() || "";
}

export async function getTradeOrderById({ orderId, orders, requests, userType, user }) {
  if (!orderId) {
    return null;
  }

  const normalizedOrderId = orderId.toString();
  const cachedOrder = orders.find(item => 0 === normalizedOrderId.localeCompare(item.oid));
  if (cachedOrder) {
    return cachedOrder.data;
  }
  if (requests[normalizedOrderId]) {
    return requests[normalizedOrderId];
  }

  try {
    requests[normalizedOrderId] = fetchOrder(userType, user, normalizedOrderId)
      .then(res => res.data);
    const order = await requests[normalizedOrderId];
    orders.push({
      "oid": normalizedOrderId,
      "data": order
    });
    return order;
  } catch (err) {
    console.error(err);
    return null;
  } finally {
    delete requests[normalizedOrderId];
  }
}

export function preloadTradeOrders({ trades, orders, requests, userType, user }) {
  trades.forEach(transaction => {
    getTradeOrderById({
      orderId: transaction.oid,
      orders,
      requests,
      userType,
      user
    });
  });
}

export function getExchangeStockTrades({ wallet, selectedItem, exchangeCode }) {
  const tradesToReturn = wallet?.s?.filter(item => {
    return normalize(item.sc) === normalize(selectedItem?.sc)
      && normalize(item.ex) === normalize(exchangeCode);
  });
  if (!tradesToReturn) {
    return [];
  }

  const remapped = [];
  tradesToReturn.forEach(item => {
    item.t?.forEach(transaction => {
      if (transaction.oid?.toString() !== "") {
        remapped.push({
          "sc": item.sc,
          "am": item.am,
          "ap": item.ap,
          "mp": item.mp,
          "cc": item.cc,
          "ex": item.ex,
          "xc": item.ex,
          "nEN": item.nEN,
          "nBG": item.nBG,
          "stid": item.stid,
          "ts": transaction.ts,
          "qty": transaction.qty,
          "sp": transaction.sp,
          "pt": transaction.pt,
          "tt": transaction.tt,
          "ot": transaction.ot,
          "oid": transaction.oid,
          "fee": transaction.fee || 0
        });
      }
    });
  });

  const seen = new Set();
  return remapped.filter(transaction => {
    const key = [
      transaction.oid,
      transaction.ts,
      transaction.qty,
      transaction.sp,
      transaction.pt,
      transaction.tt
    ].join("|");
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}
